import ResourceTagFactory from './ResourceTag'
import ResourceToolbar from './ResourceToolbar'

module.exports = (modules)->
  {React,Icon,textedit_utils,CollapsePanel,reducers,SharedReducers,slate} = modules
  ResourceTag = ResourceTagFactory(modules)
     
  # what name to use, should be unique
  name:"Resource"

  tags:{"duoresource"}

  # html to insert from drag and drop
  drophtml:'<resource-center></resource-center>'
  
  # What to render in the toolbar when element is selected
  toolbar:ResourceToolbar(modules)
  
  # what icon to show in media elements
  icon:(props)-> 
  icon:(props)-> 
    <React.Fragment>
      <div style={{border:"1px solid rgba(255.255.255.0.1)",width:48,height:35,margin:"0 auto",position:"relative"}}>
        <svg width="2.5em" height="2.5em" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <g style={{fill:"currentColor"}}>
          <path d="m78.125 28.773v7.1641h7.1641z"/>
          <path d="m18.75 67.188v21.875h34.375v-6.25h-4.6875c-0.86328 0-1.5625-0.69922-1.5625-1.5625v-14.062zm25 10.938c0 0.41406-0.16406 0.8125-0.45703 1.1055s-0.69141 0.45703-1.1055 0.45703h-12.5c-0.86328 0-1.5625-0.69922-1.5625-1.5625v-6.25c0-0.86328 0.69922-1.5625 1.5625-1.5625h12.5c0.41406 0 0.8125 0.16406 1.1055 0.45703s0.45703 0.69141 0.45703 1.1055z"/>
          <path d="m18.75 57.812h28.125v-18.75h-28.125zm9.375-14.062c0-0.86328 0.69922-1.5625 1.5625-1.5625h12.5c0.41406 0 0.8125 0.16406 1.1055 0.45703s0.45703 0.69141 0.45703 1.1055v6.25c0 0.41406-0.16406 0.8125-0.45703 1.1055s-0.69141 0.45703-1.1055 0.45703h-12.5c-0.86328 0-1.5625-0.69922-1.5625-1.5625z"/>
          <path d="m31.25 45.312h9.375v3.125h-9.375z"/>
          <path d="m31.25 17.188h9.375v3.125h-9.375z"/>
          <path d="m56.25 90.625c0 0.41406-0.16406 0.8125-0.45703 1.1055s-0.69141 0.45703-1.1055 0.45703h-37.5c-0.86328 0-1.5625-0.69922-1.5625-1.5625v-25c0-0.86328 0.69922-1.5625 1.5625-1.5625h29.688v-3.125h-29.688c-0.86328 0-1.5625-0.69922-1.5625-1.5625v-21.875c0-0.86328 0.69922-1.5625 1.5625-1.5625h29.688v-3.125h-29.688c-0.86328 0-1.5625-0.69922-1.5625-1.5625v-21.875c0-0.86328 0.69922-1.5625 1.5625-1.5625h37.5c0.41406 0 0.8125 0.16406 1.1055 0.45703s0.45703 0.69141 0.45703 1.1055v14.062h3.125v-18.75h-46.875v90.625h46.875v-12.5h-3.125z"/>
          <path d="m31.25 73.438h9.375v3.125h-9.375z"/>
          <path d="m53.125 10.938h-34.375v18.75h28.125v-4.6875c0-0.86328 0.69922-1.5625 1.5625-1.5625h4.6875zm-9.375 10.938c0 0.41406-0.16406 0.8125-0.45703 1.1055s-0.69141 0.45703-1.1055 0.45703h-12.5c-0.86328 0-1.5625-0.69922-1.5625-1.5625v-6.25c0-0.86328 0.69922-1.5625 1.5625-1.5625h12.5c0.41406 0 0.8125 0.16406 1.1055 0.45703s0.45703 0.69141 0.45703 1.1055z"/>
          <path d="m76.562 39.062c-0.86328 0-1.5625-0.69922-1.5625-1.5625v-10.938h-25v53.125h37.5v-40.625zm-20.312-3.125h15.625v3.125h-15.625zm28.125 40.625h-9.375v-3.125h9.375zm0-18.75h-31.25v-3.125h31.25zm0-6.25h-31.25v-3.125h31.25zm0-6.25h-31.25v-3.125h31.25z"/>
        </g>
        </svg>
      </div>
      <span className="label">Resource Center</span>
    </React.Fragment>

  plugins:[{ 
    schema:
      blocks:
        duoresource:
          isVoid: true
  }]
  
  # convert AST to HTML
  serialize:(object, children)->
    if object.type == "duoresource"
      return <resource-center 
        student={object.data.get("student")} 
        hide={object.data.get("hide")} 
        category={object.data.get("category")} 
        subcategory={object.data.get("subcategory")} 
        resourcetype={object.data.get("resourcetype")} 
        accesstype={object.data.get("accesstype")} 
        language={object.data.get("language")} 
        perpage={object.data.get("perpage")} 
        fields={object.data.get("fields")} 
        keyword={object.data.get("keyword")}
        author={object.data.get("author")}
        organisation={object.data.get("organisation")}
        fromyear={object.data.get("fromyear")}
        toyear={object.data.get("toyear")}
      ></resource-center>

  # convert HTML to AST
  deserialize:(el,next)->
    return if el.tagName.toLowerCase()!="resource-center"
    attributes = textedit_utils.attributesFromElement(el)
    {
      object: 'block',
      type: "duoresource",
      isVoid: true,
      data: {...attributes,style: (if el.getAttribute('style') then textedit_utils.style2object(el.getAttribute('style')) else {}),className:el.getAttribute('class')}
    }
  
  # convert AST to inpage editing component
  renderNode:({attributes, children, node, isSelected, editor} )->
    return if node.type!="duoresource"
    attributes.style = {} if !attributes.style
    attributes = Object.assign({},attributes,{className:node.data.toObject().className})
    props = node.data.toObject()
    <ResourceTag attributes={attributes} props={props} node={node} isSelected={isSelected} editor={editor} name={@name}></ResourceTag>

